import React from "react"
import clsx from "clsx"
import {RadioGroup} from "@headlessui/react"
import {CheckCircleIcon} from "@heroicons/react/20/solid"


export type HRadioOption = {
    title: string,
    description: string,
    disabled?: boolean,
    value: string
}

type HRadioProps = {
    parentField?: string,
    field: string,
    label?: string,
    register?: any,
    rules?: any,
    value?: string,
    layout?: "vertical" | "horizontal"
    setValue: (field: string, value: string) => void,
    options: HRadioOption[]
}

export function HRadio(props: HRadioProps) {
    const {register, parentField, label, rules, options, value, layout = "vertical", setValue} = props

    const field = parentField ? `${parentField}.${props.field}` : props.field

    register(field, rules)

    return (
        <RadioGroup value={value} onChange={(val) => {
            setValue(field, val)
        }}>
            {label &&
              <RadioGroup.Label className="text-base font-semibold leading-6 text-gray-900">
                  {label}
              </RadioGroup.Label>}

            <div className={clsx(
                layout === "vertical" ?
                    "-space-y-px rounded-md bg-white" :
                    "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4")}>
                {options.map((option, i) => (
                    <RadioGroup.Option
                        key={option.title}
                        value={option.value}
                        disabled={option.disabled}
                        className={({checked, active, disabled}) =>
                            clsx(
                                layout === "vertical" ? "relative flex cursor-pointer border p-4 focus:outline-none" :
                                    "relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none",
                                option.disabled && "opacity-60",
                                checked ? "border-indigo-300 bg-indigo-50" : "border-gray-300",
                                layout === "vertical" && i === 0 ? "rounded-tl-md rounded-tr-md" : "",
                                layout === "vertical" && i === options.length - 1 ? "rounded-bl-md rounded-br-md" : ""
                            )
                        }
                    >
                        {({checked}) =>
                            layout === "vertical" ?
                                (
                                    <>
                <span
                    className={clsx(
                        checked ? "bg-indigo-600 border-transparent" : "bg-white border-gray-300",
                        "mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded-full border flex items-center justify-center"
                    )}
                    aria-hidden="true"
                >
                  <span className="rounded-full bg-white w-1.5 h-1.5"/>
                </span>
                                        <span className="ml-3 flex flex-col">
                  <RadioGroup.Label
                      as="span"
                      className={clsx(checked ? "text-indigo-900" : "text-gray-900", "block text-sm font-medium")}
                  >
                    {option.title}
                  </RadioGroup.Label>
                  <RadioGroup.Description
                      as="span"
                      className={clsx(checked ? "text-indigo-700" : "text-gray-500", "block text-sm")}
                  >
                    {option.description}
                  </RadioGroup.Description>
                </span>
                                    </>
                                ) :
                                (<>
                <span className="flex flex-1">
                  <span className="flex flex-col">
                    <RadioGroup.Label as="span" className="block text-sm font-medium text-gray-900">
                      {option.title}
                    </RadioGroup.Label>
                    <RadioGroup.Description as="span" className="mt-1 flex items-center text-sm text-gray-500">
                      {option.description}
                    </RadioGroup.Description>
                  </span>
                </span>
                                    <CheckCircleIcon
                                        className={clsx(!checked ? "invisible" : "", "h-5 w-5 text-indigo-600")}
                                        aria-hidden="true"
                                    />
                                    <span
                                        className={clsx(
                                            checked ? "border-2 border-indigo-600" : "border-transparent",
                                            "pointer-events-none absolute -inset-px rounded-lg"
                                        )}
                                        aria-hidden="true"
                                    />
                                </>)
                        }
                    </RadioGroup.Option>
                ))}
            </div>


        </RadioGroup>
    )
}
